import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgmCoreModule } from "@agm/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { SharedModule } from "src/app/shared/shared.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ProgressBarModule } from "primeng/progressbar";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/components/common/messageservice";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { InputSwitchModule } from "primeng/inputswitch";
import { MultiSelectModule } from "primeng/multiselect";
import { TooltipModule } from "primeng/tooltip";
import { AppRoutingModule } from "src/app/core/app-routing.module";
import { AdministrarUsuariosComponent } from "./components/administrar-usuarios/administrar-usuarios.component";
import { LevantamientoObraComponent } from "./components/levantamiento-obra/levantamiento-obra.component";
import { AprobacionLevatamientoObrasComponent } from "./components/aprobacion-levatamiento-obras/aprobacion-levatamiento-obras.component";
import { PanelModule } from "primeng/panel";
import { LevantamientoAvanceComponent } from "./components/levantamiento-avance/levantamiento-avance.component";
import { LevantamientoActualComponent } from "./components/levantamiento-actual/levantamiento-actual.component";
import { TabViewModule } from "primeng/tabview";
import { CreacionCapasComponent } from "./components/creacion-capas/creacion-capas.component";
import { FileSizePipe } from "./pipes/file-size.pipe";
import { CreacionAvancesComponent } from "./components/creacion-avances/creacion-avances.component";
import { TreeModule } from "primeng/tree";
import { AdministrarAvancesComponent } from "./components/administrar-avances/administrar-avances.component";
import { CargaEvidenciaComponent } from "./components/carga-evidencia/carga-evidencia.component";
import { CargadorArchivoEvidenciaComponent } from "./components/cargador-archivo-evidencia/cargador-archivo-evidencia.component";
import { AdministrarPerfilesComponent } from "./components/administrar-perfiles/administrar-perfiles.component";
import { CargaFichaComponent } from "./components/carga-ficha/carga-ficha.component";
import { ObrasModule } from "../obras/obras.module";
import { ArchivosCarpetaEjecutivaComponent } from "./components/archivos-carpeta-ejecutiva/archivos-carpeta-ejecutiva.component";

@NgModule({
  declarations: [
    LevantamientoObraComponent,
    AdministrarUsuariosComponent,
    AprobacionLevatamientoObrasComponent,
    LevantamientoAvanceComponent,
    LevantamientoActualComponent,
    CreacionCapasComponent,
    CargaEvidenciaComponent,
    CargadorArchivoEvidenciaComponent,
    FileSizePipe,
    CreacionAvancesComponent,
    AdministrarAvancesComponent,
    AdministrarPerfilesComponent,
    CargaFichaComponent,
    ArchivosCarpetaEjecutivaComponent,
  ],
  imports: [
    CommonModule,
    AgmCoreModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    SharedModule,
    NgbModule,
    ProgressBarModule,
    ToastModule,
    CalendarModule,
    TableModule,
    DropdownModule,
    ScrollingModule,
    InputSwitchModule,
    MultiSelectModule,
    TooltipModule,
    AppRoutingModule,
    PanelModule,
    TabViewModule,
    TreeModule,
    ObrasModule,
  ],
  exports: [
    LevantamientoObraComponent,
    AdministrarUsuariosComponent,
    AprobacionLevatamientoObrasComponent,
    LevantamientoAvanceComponent,
    LevantamientoActualComponent,
    CreacionCapasComponent,
    CargaEvidenciaComponent,
    CargadorArchivoEvidenciaComponent,
  ],
  providers: [MessageService],
})
export class AdministracionModule {}
